
const COOKIE_KEY = {
    TOKEN: 'Token',
    DEFAULT_FACILITY_ID: 'DefaultFacilityId',
    BUILD_VERSION: 'BuildVersion',
    PAYMENT_TOKEN: 'PaymentToken',
};

export default COOKIE_KEY;
